import { render } from "./UndetectedArea.vue?vue&type=template&id=79376ed7"
import script from "./UndetectedArea.vue?vue&type=script&lang=js"
export * from "./UndetectedArea.vue?vue&type=script&lang=js"

import "./UndetectedArea.vue?vue&type=style&index=0&id=79376ed7&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__